import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './TableCellTags.css';
import Tag from '../atoms/Tag';
import CellLoader from './CellLoader';
import { Icon } from './index';
import { IconSizes } from '../foundations/Icon';

const TableCellTags = ({
    value: tags = [],
    defaultTag = '',
    defaultColor = '',
    className = '',
    tagClassName,
    color = null,
    dimensionName = '',
    isLoading = false,
    loaderClass,
    isEditMode = false,
    onDeleteTag,
}) => {
    const renderTag = (tag, tagColor, isPlaceHolder = false) => {
        const deleteIcon = isEditMode && !isPlaceHolder && (
            <Icon
                name="x"
                size={IconSizes.X_SMALL}
                className={css.deleteIcon}
                onClick={e => {
                    e.stopPropagation();
                    onDeleteTag(dimensionName, tag);
                }}
            />
        );
        return (
            <Tag
                key={`${dimensionName}-${tag}`}
                value={tag}
                color={tagColor}
                className={tagClassName}
                rightIcon={deleteIcon}
            />
        );
    };

    return (
        <td key={tags.join('_')} className={classNames(className, css.tagsContainer, { [css.loading]: isLoading })}>
            {isLoading ? (
                <CellLoader loaderClass={loaderClass} />
            ) : tags.length ? (
                tags.map(tag => renderTag(tag, color))
            ) : defaultTag ? (
                renderTag(defaultTag, defaultColor || color, true)
            ) : null}
        </td>
    );
};

TableCellTags.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string),
    defaultTag: PropTypes.string,
    defaultColor: PropTypes.string,
    className: PropTypes.string,
    tagClassName: PropTypes.string,
    color: PropTypes.string,
    dimensionName: PropTypes.string,
    isLoading: PropTypes.bool,
    loaderClass: PropTypes.string,
    isEditMode: PropTypes.bool,
    onDeleteTag: PropTypes.func,
};

export default TableCellTags;
